module.exports = __webpack_public_path__ + "static/images/time-bg2.657cf23.png";